import Icon from '../components/Icon.vue'

Icon.register({"calendar-plus":{"width":448,"height":512,"paths":[{"d":"M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM328 332C328 325.4 322.6 320 316 320H256V260C256 253.4 250.6 248 244 248H204C197.4 248 192 253.4 192 260V320H132C125.4 320 120 325.4 120 332V372C120 378.6 125.4 384 132 384H192V444C192 450.6 197.4 456 204 456H244C250.6 456 256 450.6 256 444V384H316C322.6 384 328 378.6 328 372V332z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/calendar-plus.js
// module id = null
// module chunks = 